import React from 'react';

const UiForm = (props) => {
    const {formName, children} = props
    return(
            <div className={`phViewSection phSection${formName}`}>
                { children }
            </div>
    )
}

export default UiForm